import { connect } from 'react-redux';
import { compose } from 'recompose';
import { setBonusMonth } from '../actions';
import { getBonusMonth } from '../selectors';

import BonusPeriod from '../../bonusPeriod/BonusPeriod';

const mapStateToProps = (state) => {
  return {
    bonusMonth: getBonusMonth(state),
  };
};

const mapDispatchToProps = {
  setBonusMonthAction: setBonusMonth,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(withRedux);

export default enhance(BonusPeriod);
